<template>
  <div>
    <div id="column-selector">
      <button
        type="button"
        @click="getTemplate()"
        :class="btnClass">
        Liberar para o app
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'share-posters',

    props: {
      canAllowToApp: Boolean,
      btnClass: {
        default: () => 'btn btn-secondary btn-block text-white'
      }
    },

    computed: {
      selectedPosters() {
        return this.$store.getters['printPosters/getSelectedPosters'];
      },
    },

    data() {
      return {
        posters: [],
      };
    },

    methods: {
      getTemplate() {
        if (this.selectedPosters.length == 0) {
          this.$root.throwFlashMessage('danger', 'Selecione ao menos um cartaz para compartilhar');
        } else {
          this.$root.$emit('show-share-modal', this.selectedPosters.map((poster) => poster.id));
        }

      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SharePosters.vue